import { render, staticRenderFns } from "./updateVaccine.vue?vue&type=template&id=02747945&scoped=true&"
import script from "./updateVaccine.vue?vue&type=script&lang=js&"
export * from "./updateVaccine.vue?vue&type=script&lang=js&"
import style0 from "./updateVaccine.vue?vue&type=style&index=0&id=02747945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02747945",
  null
  
)

export default component.exports